import Section from "../Section";
import Pagination from '../global/Pagination';
import QuickAdd from '../global/QuickAdd';

export default class CollectionSection extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.element = element;
    this.theme = theme;

    this.initPagination();
    this.loadQuickAdd();

    this.theme.addBadges(this.element, 1000);

    document.addEventListener('paginate', this.initPagination);
  }

  initPagination = () => {
    this.pagination = new Pagination(this.theme, this.element, this.loadQuickAdd);
  }

  loadQuickAdd = () => {
    this.quickAddButtons = new QuickAdd(this.theme, this.element);
  }

  // check if we're on mobile
  isMobile = () => {
    return window.matchMedia('(max-width: 1023px)').matches;
  }
}
